
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/redeem",
      function () {
        return require("private-next-pages/redeem/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/redeem"])
      });
    }
  